import {PageData} from '@github-ui/pull-request-page-data-tooling/page-data'
import {
  parseJSONWithBetterErrors,
  fetchWithErrorHandling,
  throwErrorsIfBadResponse,
} from '@github-ui/pull-request-page-data-tooling/fetch-error-handling'
import {useMutation} from '@github-ui/react-query'
import {useUpdateThreadComment} from '../stores/selectors'

export type UnhideCommentMutationResponse = {
  commentDatabaseId: number
  threadId: number
}

/**
 * unhides a comment
 */
export function useUnhideCommentMutation(basePath: string) {
  const apiUrl = `${basePath}/page_data/${PageData.unhideComment}`
  const updateThreadComment = useUpdateThreadComment()

  return useMutation({
    mutationFn: async ({commentDatabaseId}: {commentDatabaseId: number}) => {
      const response = await fetchWithErrorHandling(apiUrl, {
        method: 'POST',
        body: {
          commentId: commentDatabaseId,
        },
      })

      const json = await parseJSONWithBetterErrors(response)
      throwErrorsIfBadResponse(response, json)
      return json
    },
    onSuccess: (data: UnhideCommentMutationResponse) => {
      updateThreadComment({
        threadID: data.threadId,
        match: comment => comment.databaseId === data.commentDatabaseId,
        transform: oldComment => {
          if (oldComment) {
            return {...oldComment, isHidden: false, minimizedReason: null}
          }
        },
      })
    },
  })
}
